// apps/web/src/components/ui/label.tsx
//
// shadcn/ui Label primitive — simplified (no Radix dep yet; Plan 12b can swap
// to @radix-ui/react-label if accessible <label htmlFor> isn't enough).
import * as React from "react";
import { cn } from "@/lib/utils";

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      className={cn(
        "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        className,
      )}
      {...props}
    />
  ),
);
Label.displayName = "Label";
